import styled from 'styled-components';

const GREEN_COLOR = '#2CC852';
const YELLOW_COLOR = '#F8D627';
const RED_COLOR = '#E74150';
const PURPLE_COLOR = '#9B54E2';

const RISK_COLOR: Record<number, string> = {
	1: GREEN_COLOR,
	2: YELLOW_COLOR,
	3: RED_COLOR,
	4: PURPLE_COLOR
};

interface ScoreProps {
	$score?: number;
	$fontSize?: string;
}

export const Container = styled.div<ScoreProps>`
	width: 100%;
	height: 100%;
	display: flex;
	border-radius: 6px;
	align-items: center;
	justify-content: center;
	border: 2px solid ${({ $score }) => ($score ? RISK_COLOR[$score] : '#e6e8e8')};
	background-color: ${({ $score }) => ($score ? RISK_COLOR[$score] : '#F8F8F8')};

	span {
		font-weight: 600;
		font-size: ${({ $fontSize }) => $fontSize};
		color: ${({ $score }) => ($score ? '#FFFFFF' : '#e6e8e8')};
	}
`;
